{
  "deselectedItem": "{item} não selecionado.",
  "select": "Selecionar",
  "selectedAll": "Todos os itens selecionados.",
  "selectedCount": "{count, plural, =0 {Nenhum item selecionado} one {# item selecionado} other {# itens selecionados}}.",
  "selectedItem": "{item} selecionado."
}
